package org.zq.astrock_ai.network

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import org.zq.astrock_ai.api.dto.AgentChatRequestDto
import org.zq.astrock_ai.api.dto.AgentChatResponseDto
import org.zq.astrock_ai.api.dto.AgentHealthDto

class StockAgentApiClient(
    private val client: HttpClient = createMarketHttpClient(),
    private val baseUrl: String = apiBaseUrl(),
) {
    suspend fun health(): AgentHealthDto =
        client.get("$baseUrl/api/ai/health").body()

    suspend fun chat(request: AgentChatRequestDto): AgentChatResponseDto =
        client.post("$baseUrl/api/ai/chat") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()
}
